import { _ as r } from "../internals/export.js";
import { i as t } from "../internals/is-integral-number.js";
var a = Math.abs;
r({
  target: "Number",
  stat: !0
}, {
  isSafeInteger: function isSafeInteger(r) {
    return t(r) && 9007199254740991 >= a(r);
  }
});